import { init } from "marko/dist/runtime/components";
import "./components/app.marko";
init();